// ** Reducers Imports
import publicStore from "../pages/store";
import homeStore from "../pages/Home/store";
import panelStore from "../pages/Panel/store";

const rootReducer = {
  publicStore,
  homeStore,
  panelStore,
};

export default rootReducer;
